import { GetStaticProps } from 'next'

import Layout from '@/cmp/templates/Layout/Layout'
import ContentOps from '@/cmp/templates/ContentOps'

/* utils */
import { getStrapiGraphqlData } from '@/utils/api/wrapper'
import { TEN_MINS_REVALIDATION } from '@/utils/constants/revalidation'
import {
  contentOpsDetailsQuery,
  ContentOpsPageAttributes,
  ContentOpsPageResponse
} from '@/utils/queries/product/content_ops'
import { constructMetadataFromStrapiData } from '@/utils/functions/strapi'
import { constructFaqJsonSchema } from '@/utils/functions/jsonSchema'

interface Props {
  readonly data: ContentOpsPageAttributes
}

function ContentOpsPage({ data }: Props): JSX.Element {
  return (
    <Layout
      title={data.seo.title}
      meta={constructMetadataFromStrapiData(data.seo)}
      jsonSchema={[constructFaqJsonSchema(data.faqs)]}
      canonical="/product/content-os/"
    >
      <ContentOps data={data} />
    </Layout>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  const result = await getStrapiGraphqlData<ContentOpsPageResponse>(
    contentOpsDetailsQuery.loc?.source.body
  )

  return {
    props: {
      data: result.page.data.attributes
    },
    revalidate: TEN_MINS_REVALIDATION
  }
}

export default ContentOpsPage
